import { IQuestion } from '@quizzach/interfaces';
import { TextSize, Text, Colors } from '@quizzach/styles';
import { useTranslation } from 'react-i18next';

export const ImageCredits = ({
	currentQuestion,
}: {
	currentQuestion: IQuestion;
}) => {
	const { t } = useTranslation();

	return (
		<div className='img-credits' onClick={(e) => e.stopPropagation()}>
			<Text
				$size={TextSize.xxs}
				color={Colors.surfaceNeutral}
				style={{ margin: 0 }}
			>
				<a
					href={currentQuestion.visual_question?.original_photo_url}
					target='_blank'
					rel='noopener noreferrer'
					style={{ color: '#616264' }}
				>
					{t('common.imageCredits.photo')}
				</a>{' '}
				{currentQuestion.visual_question?.photo_author_name ? (
					<>
						{t('common.imageCredits.by')}{' '}
						{currentQuestion.visual_question?.photo_author_name} |{' '}
					</>
				) : (
					<> | </>
				)}
				<a
					href={currentQuestion.visual_question?.licence_link}
					target='_blank'
					rel='noopener noreferrer'
					style={{ color: '#616264' }}
				>
					{currentQuestion.visual_question?.licence_name}
				</a>
			</Text>
		</div>
	);
};
